export default {"src":"/_next/static/media/disable-calender.246ac681.svg","height":18,"width":16,"blurWidth":0,"blurHeight":0};